import React, { useEffect, useState } from 'react';
import Skeleton from 'react-loading-skeleton';

import {
  ConnectorModel,
  ELMA365ConnectorSettingsOutput,
  ELMA365GeneralToolsetSettingsOutput,
} from '../../../../../../gamma-api';
import { getTranslateFunc } from '../../../../../utils/stringUtil';
import { defaultApi } from '../../../../../apis';
import IbDivider from '../../../../../components/common/IbDivider';
import IbTypography from '../../../../../components/common/IbTypography';

import { FOOTER_CLASS_NAME, SECTION_CLASS_NAME, SKELETON_HEIGHT, SKELETON_WIDTH } from './const';
import BaseToolsetListItem from './BaseToolsetListItem';

import { IToolsetListItemProps } from './index';

const ELMA365GeneralToolset: React.FC<IToolsetListItemProps> = ({
  toolset,
  onSetup,
  onDelete,
  onToolsetStateChange,
}) => {
  const [loading, setLoading] = useState(false);
  const [connector, setConnector] = useState<ConnectorModel>();

  const settings = toolset.settings as ELMA365GeneralToolsetSettingsOutput;
  const translate = getTranslateFunc('Agent: Toolset: List: Item: ELMA365 General:');

  const fetchConnector = async () => {
    if (!settings.connector_id) return;
    try {
      setLoading(true);
      const response = await defaultApi.getOneConnector(settings.connector_id);
      setConnector(response.data);
    } catch (err) {
      // eslint-disable-next-line no-console
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => void fetchConnector(), [settings.connector_id]);

  const getConnectorInfo = (): string => {
    if (!connector) return '–';
    const elma365ConnectorSettings = connector.settings as ELMA365ConnectorSettingsOutput;
    const authType = translate(`Connector: ${elma365ConnectorSettings.apis.web.auth.type}`);
    return `${connector.name} – ${authType} – ${elma365ConnectorSettings.apis.web.url}`;
  };

  const renderFooter = () => {
    return (
      <>
        <IbDivider />
        <div className={FOOTER_CLASS_NAME}>
          <div className={SECTION_CLASS_NAME}>
            <IbTypography.Paragraph disabled>{translate('Connector')}</IbTypography.Paragraph>
            {loading ? (
              <Skeleton height={SKELETON_HEIGHT} width={SKELETON_WIDTH} />
            ) : (
              <IbTypography.Paragraph>{getConnectorInfo()}</IbTypography.Paragraph>
            )}
          </div>
        </div>
      </>
    );
  };

  const getToolCount = () => {
    let toolCount = 0;
    settings.fetch_app_element_tool_settings.enabled && toolCount++;
    settings.fetch_app_feed_tool_settings.enabled && toolCount++;
    settings.fetch_current_user_tool_settings.enabled && toolCount++;
    settings.read_file_tool_settings.enabled && toolCount++;
    settings.describe_image_tool_settings.enabled && toolCount++;
    settings.search_elma365_tasks_tool_settings.enabled && toolCount++;
    settings.fetch_elma365_task_tool_settings.enabled && toolCount++;
    settings.create_elma365_task_tool_settings.enabled && toolCount++;
    settings.reassign_elma365_task_tool_settings.enabled && toolCount++;
    settings.update_elma365_task_percent_tool_settings.enabled && toolCount++;
    settings.update_elma365_task_dates_tool_settings.enabled && toolCount++;
    settings.fetch_docflow_lists_tool_settings.enabled && toolCount++;
    return toolCount;
  };

  return (
    <BaseToolsetListItem
      footer={renderFooter()}
      loading={loading}
      toolCount={getToolCount()}
      toolset={toolset}
      onDelete={onDelete}
      onSetup={onSetup}
      onToolsetStateChange={onToolsetStateChange}
    />
  );
};

export default ELMA365GeneralToolset;
